<template lang="html">
<div ref="mapElem" :id="mapId" :style="{ width, height }" ></div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';

export default {
    name: 'YandexMap',
    emits : [ 'selected', 'placemark:selected' ],
    props : {
        placemarks : {
            type : Array,
            default : () => ([]),
        },
        addressSelecting : {
            type : Boolean,
            default : false,
        },
        address : {
            type : String,
            default : '',
        },
        width : {
            type : String,
            default : '100%',
        },
        height : {
            type : String,
            default : '400px',
        },
        center : {
            type : Array,
            default : () => ([]),
        },
        zoom : {
            type : [ String, Number ],
            default : 11,
        },
    },
    setup (props, { emit }) {
        const mapElem = ref(null);
        let map = null;
        const mapId = ref('map-'+Math.random().toString(36).substring(7));

        const initMap = () => {
            return new Promise(resolve => {
                if( typeof(window.ymaps) == 'undefined' ) {
                    window.ymaps = null;
                    let script = document.createElement("script");
                    script.src ="https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=e60b3f0c-4bd7-4681-b712-2620da9f9966";
                    script.onload = () => {
                        window.ymaps.ready(() => {
                            resolve(window.ymaps);
                        });
                    };
                    document.body.appendChild(script);
                }
                else if (window.ymaps)
                {
                    window.ymaps.ready(() => {
                        resolve(window.ymaps);
                    });
                }
            });
        }

        const buildMap = () => {
            initMap().then(ymaps => {
                let i;
                let avgLat = 0;
                let avgLng = 0;
                for (i = 0; i < props.placemarks.length; i++) {
                    avgLat += +props.placemarks[i].coords[0];
                    avgLng += +props.placemarks[i].coords[1];
                }
                avgLat /= props.placemarks.length;
                avgLng /= props.placemarks.length;
                let center = [];
                if (props.center && props.center.filter(v=> +v).length == 2) {
                    center = props.center;
                }
                else if (props.placemarks.length) {
                    center = [ avgLat, avgLng ];
                }
                else {
                    center = [55.0944,61.2411];
                }
                mapElem.value.innerHTML = '';
                map = new ymaps.Map(mapId.value, {
                    // controls: [],
                    center,
                    zoom : props.zoom,
                });
                map.controls.add(
                    new ymaps.control.ZoomControl(),
                );
                map.controls.add("typeSelector");
                let geoObjects = [];
                for (i = 0; i < props.placemarks.length; i++) {
                    if (!props.placemarks[i].coords) {
                        continue;
                    }
                    let placemark =new ymaps.Placemark(
                        props.placemarks[i].coords,
                        {},
                        {
                            iconLayout      : "default#image",
                            iconImageHref   : "/local/templates/roscar/img/svg/icon-map.svg",
                            iconImageSize   : [37, 53],
                            iconImageOffset : [-18, -53],
                        }
                    );
                    ((placemark, item) => {
                        placemark.events.add('click', () => {
                            emit('placemark:selected', {
                                item,
                                placemark,
                            });
                        });
                    })(placemark, props.placemarks[i])
                    geoObjects.push(placemark);
                }
                let clusterer = new ymaps.Clusterer({
                    preset: 'islands#redClusterIcons',
                    hasBalloon: false,
                    gridSize: 80,
                });
                clusterer.add(geoObjects);
                map.geoObjects.add(clusterer);

                if (props.addressSelecting) {
                    let addressSelectingPlacemark;

                    const createPlacemark = coords => {
                        return new ymaps.Placemark(coords, {
                            iconCaption: 'поиск...'
                        }, {
                            iconLayout      : "default#image",
                            iconImageHref   : "/local/templates/roscar/img/svg/icon-map.svg",
                            iconImageSize   : [37, 53],
                            iconImageOffset : [-18, -53],
                        });
                    }

                    const getAddress = coords => {
                        addressSelectingPlacemark.properties.set('iconCaption', 'поиск...');
                        ymaps.geocode(coords).then(res => {
                            let firstGeoObject = res.geoObjects.get(0);
                            emit('selected', {
                                address : firstGeoObject.getAddressLine(),
                            });
                            addressSelectingPlacemark.properties.set({
                                iconCaption : firstGeoObject.getAddressLine(),
                                // balloonContent: firstGeoObject.getAddressLine()
                            });
                        });
                    }

                    map.events.add('click', e => {
                        var coords = e.get('coords');
                        if (addressSelectingPlacemark) {
                            addressSelectingPlacemark.geometry.setCoordinates(coords);
                        }
                        else {
                            addressSelectingPlacemark = createPlacemark(coords);
                            map.geoObjects.add(addressSelectingPlacemark);
                            addressSelectingPlacemark.events.add('dragend', () => {
                                getAddress(addressSelectingPlacemark.geometry.getCoordinates());
                            });
                        }
                        getAddress(coords);
                    });
                }

            });
        }

        onMounted(() => {
            buildMap();
        });

        watch(() => props.placemarks, () => {
            buildMap();
        })
        watch(() => props.center, () => {
            if (map && props.center && props.center.filter(v=>+v).length == 2) {
                map.setCenter(props.center);
            }
        })
        watch(() => props.zoom, () => {
            if (map && +props.zoom) {
                map.setZoom(props.zoom);
            }
        })

        return {
            mapId,
            mapElem,
        };
    },
}
</script>
